import classNames from 'classnames';
import { bool, func, node, object, shape, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Map } from '../../../../components';
import SectionContainer from '../SectionContainer';
import { types as sdkTypes } from '../../../../util/sdkLoader';
const { LatLng } = sdkTypes;

import css from './SectionMap.module.css';

export const CORRDINATES = {
  "africa": {
    "lat": 1.6508,
    "lng": 17.0828,
    "limitSearch": [
      "DZ", "AO", "BJ", "BW", "BF", "BI", "CM", "CV", "CF", "TD", "KM", "CD", "CG", "CI", "DJ",
      "EG", "GQ", "ER", "SZ", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS", "LR", "LY", "MG",
      "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG", "RW", "ST", "SN", "SC", "SL", "SO",
      "ZA", "SS", "SD", "TZ", "TG", "TN", "UG", "ZM", "ZW"
    ],
    "name": "Africa",
    "zoomLevel": 2,
    "isRegion":true
  },
  "algeria": {
    "lat": 28.0339,
    "lng": 1.6596,
    "limitSearch": ["DZ"]
  },
  "albania": {
    "lat": 41.1533,
    "lng": 20.1683,
    "limitSearch": ["AL"],
    "zoomLevel": 6,
    "name": "Albania"
  },
  "andorra": {
    "lat": 42.5063,
    "lng": 1.5218,
    "limitSearch": ["AD"]
  },
  "antarctica": {
    "lat": -82.8628,
    "lng": 135.0000,
    "limitSearch": ["AQ"]
  },
  "angola": {
    "lat": -11.2027,
    "lng": 17.8739,
    "limitSearch": ["AO"]
  },
  "antigua-and-barbuda": {
    "lat": 17.0608,
    "lng": -61.7964,
    "limitSearch": ["AG"]
  },
  "argentina": {
    "lat": -38.4161,
    "lng": -63.6167,
    "limitSearch": ["AR"],
    "zoomLevel": 3,
    "name": "Argentina"
  },
  "armenia": {
    "lat": 40.0691,
    "lng": 45.0382,
    "limitSearch": ["AM"],
    "name": "Armenia",
    "zoomLevel": 6
  },
  "arruba": {
    "lat": 12.5211,
    "lng": -69.9683,
    "limitSearch": ["AW"],
    "name": "Arruba",
    "zoomLevel": 10
  },

  "australia": {
    "lat": -25.2744,
    "lng": 133.7751,
    "limitSearch": ["AU"],
    "zoomLevel": 3,
    "name": "Australia"
  },
  "austria": {
    "lat": 47.5162,
    "lng": 14.5501,
    "limitSearch": ["AT"],
    "zoomLevel": 6,
    "name": "Austria"
  },
  "azerbaijan": {
    "lat": 40.1431,
    "lng": 47.5769,
    "limitSearch": ["AZ"]
  },
  "bahamas": {
    "lat": 25.0343,
    "lng": -77.3963,
    "limitSearch": ["BS"],
    "zoomLevel": 11,
    "name": "Bahamas"
  },
  "barbados": {
    "lat": 13.1939,
    "lng": -59.5432,
    "limitSearch": ["BB"],
    "zoomLevel": 10,
    "name": "Barbados"
  },
  "bahrain": {
    "lat": 26.0667,
    "lng": 50.5577,
    "limitSearch": ["BH"],
    "zoomLevel": 9,
    "name": "Bahrain"
  },
  "belarus": {
    "lat": 53.9006,
    "lng": 27.5590,
    "limitSearch": ["BY"]
  },
  "belgium": {
    "lat": 50.8503,
    "lng": 4.3517,
    "limitSearch": ["BE"],
    "zoomLevel": 7,
    "name": "Belgium"
  },
  "belize": {
    "lat": 17.1899,
    "lng": -88.4976,
    "limitSearch": ["BZ"],
    "zoomLevel": 7,
    "name": "Belize"
  },
  "benin": {
    "lat": 9.3077,
    "lng": 2.3158,
    "limitSearch": ["BJ"]
  },
  "bolivia": {
    "lat": -16.2902,
    "lng": -63.5887,
    "limitSearch": ["BO"],
    "zoomLevel": 4,
    "name": "Bolivia"
  },
  "bosnia-and-herzegovina": {
    "lat": 43.9159,
    "lng": 17.6791,
    "limitSearch": ["BA"]
  },
  "botswana": {
    "lat": -22.3285,
    "lng": 24.6849,
    "limitSearch": ["BW"],
    "zoomLevel": 5,
    "name": "Botswana"
  },
  "brazil": {
    "lat": -14.2350,
    "lng": -51.9253,
    "limitSearch": ["BR"],
    "zoomLevel": 2,
    "name": "Brazil"
  },
  "bulgaria": {
    "lat": 42.7339,
    "lng": 25.4858,
    "limitSearch": ["BG"],
    "name": "Bulgaria"
  },
  "burkina-faso": {
    "lat": 12.2383,
    "lng": -1.5616,
    "limitSearch": ["BF"]
  },
  "canada": {
    "lat": 56.1304,
    "lng": -106.3468,
    "limitSearch": ["CA"],
    "zoomLevel": 4,
    "name": "Canada"
  },
  "cabo_verde": {
    "lat": 16.5388,
    "lng": -23.0418,
    "limitSearch": ["CV"],
    "name": "Cabo Verde",
    "zoomLevel": 6
  },
  "cambodia": {
    "lat": 12.5657,
    "lng": 104.991,
    "limitSearch": ["KH"],
    "name": "Cambodia",
    "zoomLevel": 6
  },
  "carribean": {
    "lat": 18.5,
    "lng": -68.5,
    limitSearch: [
      "AG", "BS", "BB", "CU", "DM", "DO", "GD", "HT", "JM", "KN", "LC", "VC", "TT"
    ],
    "name": "Carribean",
    "zoomLevel": 3,
    "isRegion":true
  },
  "central-america": {
    "lat": 13.5,
    "lng": -85.0,
    limitSearch: ["BZ", "CR", "SV", "GT", "HN", "NI", "PA"],
    "name": "Central America",
    "zoomLevel": 3,
    "isRegion":true
  },
  "central-and-north-asia": {
    "lat": 50.0000,
    "lng": 80.0000,
    "limitSearch": [
      "RU", "KZ", "KG", "TJ", "TM", "UZ", "MN"
    ],
    limitSearch: ["KZ", "KG", "TJ", "TM", "UZ", "RU", "MN"],
    "name": "Central And North Asia",
    "zoomLevel": 1,
    "isRegion":true
  },
  "central-asia": {
    "lat": 44.0,
    "lng": 69.0,
    limitSearch: ["KZ", "KG", "TJ", "TM", "UZ"]
  },
  "chile": {
    "lat": -35.6751,
    "lng": -71.5430,
    "limitSearch": ["CL"],
    "zoomLevel": 4,
    "name": "Chile"
  },
  "china": {
    "lat": 35.8617,
    "lng": 104.1954,
    "limitSearch": ["CN"]
  },
  "colombia": {
    "lat": 4.5709,
    "lng": -74.2973,
    "limitSearch": ["CO"],
    "zoomLevel": 5,
    "name": "Colombia"
  },
  "costa-rica": {
    "lat": 9.7489,
    "lng": -83.7534,
    "limitSearch": ["CR"],
    "zoomLevel": 7,
    "name": "Costa Rica"
  },
  "croatia": {
    "lat": 45.1000,
    "lng": 15.2000,
    "limitSearch": ["HR"],
    "zoomLevel": 6,
    "name": "Croatia"
  },
  "cuba": {
    "lat": 21.5218,
    "lng": -77.7812,
    "limitSearch": ["CU"],
    "zoomLevel": 6,
    "name": "Cuba"
  },
  "cyprus": {
    "lat": 35.1264,
    "lng": 33.4299,
    "limitSearch": ["CY"],
    "zoomLevel": 8,
    "name": "Cyprus"
  },
  "czech_republic": {
    "lat": 49.8175,
    "lng": 15.4730,
    "limitSearch": ["CZ"],
    "zoomLevel": 6,
    "name": "Czech Republic"
  },
  "denmark": {
    "lat": 56.2639,
    "lng": 9.5018,
    "limitSearch": ["DK"],
    "zoomLevel": 6,
    "name": "Denmark"
  },
  "denmark_aarhus": {
    "lat": 56.15674,
    "lng": 10.21076,
    "limitSearch": ["DK"],
    "name": "Aarhus"
  },
  "dominican_republic": {
    "lat": 18.7357,
    "lng": -70.1627,
    "limitSearch": ["DO"],
    "name": "Dominican Republic",
    "zoomLevel": 7
  },
  "ecuador": {
    "lat": -1.8312,
    "lng": -78.1834,
    "limitSearch": ["EC"],
    "zoomLevel": 6,
    "name": "Ecuador"
  },
  "egypt": {
    "lat": 26.8206,
    "lng": 30.8025,
    "limitSearch": ["EG"],
    "zoomLevel": 5,
    "name": "Egypt"
  },
  "el-salvador": {
    "lat": 13.7942,
    "lng": -88.8965,
    "limitSearch": ["SV"],
    "zoomLevel": 8,
    "name": "El Salvador"
  },
  "estonia": {
    "lat": 58.5953,
    "lng": 25.0136,
    "limitSearch": ["EE"],
    "zoomLevel": 6,
    "name": "Estonia"
  },
  "europe": {
    lat: 54.8566,
    "lng": 11.2551,
    "limitSearch": ["AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI", "ES", "SE", "CH", "UA", "GB", "VA"],
    "zoomLevel": 3,
    "name": "Europe",
    "isRegion":true
  },
  "fiji": {
    "lat": -17.7134,
    "lng": 178.0650,
    "limitSearch": ["FJ"],
    "zoomLevel": 8,
    "name": "Fiji"
  },
  "finland": {
    "lat": 61.9241,
    "lng": 25.7482,
    "limitSearch": ["FI"],
    "zoomLevel": 5,
    "name": "Finland"
  },
  "france": {
    "lat": 46.2276,
    "lng": 2.2137,
    "limitSearch": ["FR"],
    "name": "France"
  },
  "france_alps": {
    "lat": 45.8326492,
    "lng": 6.8527504,
    "limitSearch": ["FR"],
    "name": "Alps"
  },
  "france_alsace": {
    "lat": 48.3181795,
    "lng": 7.4416241,
    "limitSearch": ["FR"],
    "name": "Alsace"
  },
  "french-polynesia": {
    "lat": -17.5516,
    "lng": -149.5585,
    "limitSearch": ["PF"],
    "name": "French Polynesia",
    "zoomLevel": 6
  },
  "germany": {
    "lat": 51.1657,
    "lng": 10.4515,
    "limitSearch": ["DE"],
    "zoomLevel": 4,
    "name": "Germany"
  },
  "germany_alps": {
    "lat": 47.5,
    "lng": 11.0,
    "limitSearch": ["DE"],
    "name": "Alps"
  },
  "georgia": {
    "lat": 42.3154,
    "lng": 43.3569,
    "limitSearch": ["GE"],
    "name": "Georgia",
    "zoomLevel": 7
  },
  "ghana": {
    "lat": 7.9465,
    "lng": -1.0232,
    "limitSearch": ["GH"],
    "name": "Ghana",
    "zoomLevel": 6
  },
  "greece": {
    "lat": 39.0742,
    "lng": 21.8243,
    "limitSearch": ["GR"],
    "zoomLevel": 6,
    "name": "Greece"
  },
  "greenland": {
    "lat": 71.7069,
    "lng": -42.6043,
    "limitSearch": ["GL"],
    "zoomLevel": 3,
    "name": "Greenland"
  },
  "guatemala": {
    "lat": 15.7835,
    "lng": -90.2308,
    "limitSearch": ["GT"],
    "zoomLevel": 6,
    "name": "Guatemala"
  },
  "honduras": {
    "lat": 15.2000,
    "lng": -86.2419,
    "limitSearch": ["HN"],
    "zoomLevel": 6,
    "name": "Honduras"
  },
  "hong-kong": {
    "lat": 22.3193,
    "lng": 114.1694,
    "limitSearch": ["HK"]
  },
  "hungary": {
    "lat": 47.1625,
    "lng": 19.5033,
    "limitSearch": ["HU"],
    "name": "Hungary",
    "zoomLevel": 6
  },
  "iceland": {
    "lat": 64.9631,
    "lng": -19.0208,
    "limitSearch": ["IS"],
    "zoomLevel": 6,
    "name": "Iceland"
  },
  "iceland_akureyri": {
    "lat": 65.68353,
    "lng": -18.0878,
    "limitSearch": ["IS"],
    "name": "Akureyri"
  },
  "india": {
    "lat": 20.5937,
    "lng": 78.9629,
    "limitSearch": ["IN"],
    "zoomLevel": 4,
    "name": "India"
  },
  "indonesia": {
    "lat": -0.7893,
    "lng": 113.9213,
    "limitSearch": ["ID"],
    "name": "Indonesia"
  },
  "ireland": {
    "lat": 53.1424,
    "lng": -7.6921,
    "limitSearch": ["IE"],
    "zoomLevel": 6,
    "name": "Ireland"
  },
  "iran": {
    "lat": 32.4279,
    "lng": 53.6880,
    "limitSearch": ["IR"]
  },
  "iraq": {
    "lat": 33.2232,
    "lng": 43.6793,
    "limitSearch": ["IQ"]
  },
  "israel": {
    "lat": 31.0461,
    "lng": 34.8516,
    "limitSearch": ["IL"],
    "zoomLevel": 6,
    "name": "Israel"
  },
  "italy": {
    "lat": 41.8719,
    "lng": 12.5674,
    "limitSearch": ["IT"],
    "name": "Italy"
  },
  "japan": {
    "lat": 36.2048,
    "lng": 138.2529,
    "limitSearch": ["JP"],
    "name": "Japan"
  },
  "jordan": {
    "lat": 30.5852,
    "lng": 36.2384,
    "limitSearch": ["JO"],
    "zoomLevel": 6,
    "name": "Jordan"
  },
  "jamaica": {
    "lat": 18.1096,
    "lng": -77.2975,
    "limitSearch": ["JM"],
    "zoomLevel": 8,
    "name": "Jamaica"
  },
  "kazakhstan": {
    "lat": 48.0196,
    "lng": 66.9237,
    "limitSearch": ["KZ"],
    "name": "Kazakhstan"
  },
  "kyrgystan": {
    "lat": 41.2044,
    "lng": 74.7661,
    "limitSearch": ["KG"],
    "name": "Kyrgystan",
    "zoomLevel": 6
  },
  "kenya": {
    "lat": -0.0236,
    "lng": 37.9062,
    "limitSearch": ["KE"],
    "name": "Kenya"
  },
  "kyrgyzstan": {
    "lat": 41.2044,
    "lng": 74.7661,
    "limitSearch": ["KG"]
  },
  "latvia": {
    "lat": 56.8796,
    "lng": 24.6032,
    "limitSearch": ["LV"],
    "zoomLevel": 6,
    "name": "Latvia"
  },
  "lithuania": {
    "lat": 55.1694,
    "lng": 23.8813,
    "limitSearch": ["LT"],
    "zoomLevel": 6,
    "name": "Lithuania"
  },
  "laos": {
    "lat": 19.8563,
    "lng": 102.4955,
    "limitSearch": ["LA"],
    "name": "Laos",
    "zoomLevel": 6
  },
  "luxembourg": {
    "lat": 49.8153,
    "lng": 6.1296,
    "limitSearch": ["LU"]
  },
  "malaysia": {
    "lat": 4.2105,
    "lng": 101.9758,
    "limitSearch": ["MY"],
    "name": "Malaysia"
  },
  "malta": {
    "lat": 35.9375,
    "lng": 14.3754,
    "limitSearch": ["MT"],
    "zoomLevel": 10,
    "name": "Malta"
  },
  "madagascar": {
    "lat": -18.7669,
    "lng": 46.8691,
    "limitSearch": ["MG"],
    "name": "Madagascar",
    "zoomLevel": 5
  },
  "marshall_islands": {
    "lat": 7.1315,
    "lng": 171.1845,
    "limitSearch": ["MH"],
    "name": "Marshall Islands",
    "zoomLevel": 11
  },
  "mauritius": {
    "lat": -20.3484,
    "lng": 57.5522,
    "limitSearch": ["MU"],
    "name": "mauritius",
    "zoomLevel": 9
  },
  "myanmar": {
    "lat": 21.9139,
    "lng": 95.9560,
    "limitSearch": ["MM"],
    "name": "Myanmar",
    "zoomLevel": 6
  },
  "mexico": {
    "lat": 23.6345,
    "lng": -102.5528,
    "limitSearch": ["MX"],
    "zoomLevel": 4,
    "name": "Mexico"
  },
  "middle-east": {
    "lat": 26.0,
    "lng": 50.0,
    "limitSearch": ["BH", "IR", "IQ", "IL", "JO", "KW", "LB", "OM", "PS", "QA", "SA", "SY", "AE", "YE"],
    "name": "Middle East",
    "zoomLevel": 4,
    "isRegion":true
  },
  "mongolia": {
    "lat": 46.8625,
    "lng": 103.8467,
    "limitSearch": ["MN"],
    "zoomLevel": 4,
    "name": "Mongolia"
  },
  "montenegro": {
    "lat": 42.7087,
    "lng": 19.3744,
    "limitSearch": ["ME"],
    "name": "montenegro",
    "zoomLevel": 7
  },
  "morocco": {
    "lat": 31.7917,
    "lng": -7.0926,
    "limitSearch": ["MA"],
    "name": "Morocco"
  },
  "namibia": {
    "lat": -22.9576,
    "lng": 18.4904,
    "limitSearch": ["NA"],
    "zoomLevel": 5,
    "name": "Namibia"
  },
  "netherlands": {
    "lat": 52.1326,
    "lng": 5.2913,
    "limitSearch": ["NL"],
    "zoomLevel": 6,
    "name": "Netherlands"
  },
  "new-zealand": {
    "lat": -40.9006,
    "lng": 174.8860,
    "limitSearch": ["NZ"],
    "zoomLevel": 4,
    "name": "New Zealand"
  },
  "nicaragua": {
    "lat": 12.1696,
    "lng": -86.4900,
    "limitSearch": ["NI"],
    "zoomLevel": 6,
    "name": "Nicaragua"
  },
  "north-america": {
    "lat": 45.0,
    "lng": -100.0,
    "limitSearch": ["CA", "US", "MX"],
    "name": "North America",
    "zoomLevel": 4,
    "isRegion":true
  },
  "nepal": {
    "lat": 28.3949,
    "lng": 84.1240,
    "limitSearch": ["NP"],
    "name": "Nepal",
    "zoomLevel": 6
  },
  "norway": {
    "lat": 60.4720,
    "lng": 8.4689,
    "limitSearch": ["NO"],
    "name": "Norway"
  },
  "norway_alta": {
    "lat": 69.9689,
    "lng": 23.2716,
    "limitSearch": ["NO"],
    "name": "Alta"
  },
  "oceania": {
    "lat": -15.3767,
    "lng": 166.9592,
    "limitSearch": ["AU", "FJ", "KI", "MH", "FM", "NR", "NZ", "PW", "PG", "WS", "SB", "TO", "TV", "VU"],
    "zoomLevel": 2,
    "name": "Oceania",
    "isRegion":true
  },
  "oman": {
    "lat": 21.4267,
    "lng": 55.9433,
    "limitSearch": ["OM"],
    "name": "Oman"
  },
  "panama": {
    "lat": 8.5380,
    "lng": -80.7821,
    "limitSearch": ["PA"],
    "zoomLevel": 7,
    "name": "Panama"
  },
  "papua_new_guinea": {
    "lat": -6.3150,
    "lng": 143.9555,
    "limitSearch": ["PG"],
    "name": "Papua New Guinea"
  },
  "palau": {
    "lat": 7.5149,
    "lng": 134.5825,
    "limitSearch": ["PW"],
    "name": "Palau",
    "zoomLevel": 9
  },
  "paraguay": {
    "lat": -23.4425,
    "lng": -58.4438,
    "limitSearch": ["PY"],
    "name": "paraguay",
    "zoomLevel": 6
  },
  "peru": {
    "lat": -9.1900,
    "lng": -75.0152,
    "limitSearch": ["PE"],
    "zoomLevel": 4,
    "name": "Peru"
  },
  "philippines": {
    "lat": 12.8797,
    "lng": 121.7740,
    "limitSearch": ["PH"],
    "name": "Philippines"
  },
  "poland": {
    "lat": 51.9194,
    "lng": 19.1451,
    "limitSearch": ["PL"],
    "name": "Poland"
  },
  "portugal": {
    "lat": 39.3999,
    "lng": -8.2245,
    "limitSearch": ["PT"],
    "zoomLevel": 5,
    "name": "Portugal"
  },
  "portugal_algarve": {
    "lat": 37.019356,
    "lng": -7.930440,
    "limitSearch": ["PT"],
    "name": "Algarve"
  },
  "puerto_rico": {
    "lat": 18.2208,
    "lng": -66.5902,
    "limitSearch": ["PR"],
    "name": "Puerto Rico",
    "zoomLevel": 9
  },
  "qatar": {
    "lat": 25.276987,
    "lng": 51.520008,
    "limitSearch": ["QA"],
    "name": "Qatar",
    "zoomLevel": 7
  },
  "rwanda": {
    "lat": -1.9403,
    "lng": 29.8739,
    "limitSearch": ["RW"],
    "name": "Rwanda",
    "zoomLevel": 6
  },
  "romania": {
    "lat": 45.9432,
    "lng": 24.9668,
    "limitSearch": ["RO"],
    "zoomLevel": 5,
    "name": "Romania"
  },
  "russia": {
    "lat": 61.5240,
    "lng": 105.3188,
    "limitSearch": ["RU"]
  },
  "samoa": {
    "lat": -13.7590,
    "lng": -172.1046,
    "limitSearch": ["WS"],
    "zoomLevel": 9,
    "name": "Samoa"
  },
  "saudi_arabia": {
    "lat": 23.8859,
    "lng": 45.0792,
    "limitSearch": ["SA"],
    "name": "Saudi Arabia",
    "zoomLevel": 5
  },
  "seychelles": {
    "lat": -4.6796,
    "lng": 55.4920,
    "limitSearch": ["SC"],
    "name": "seychelles",
    "zoomLevel": 9
  },
  "singapore": {
    "lat": 1.3521,
    "lng": 103.8198,
    "limitSearch": ["SG"],
    "zoomLevel": 10,
    "name": "Singapore"
  },
  "slovakia": {
    "lat": 48.6690,
    "lng": 19.6990,
    "limitSearch": ["SK"],
    "name": "Slovakia"
  },
  "slovenia": {
    "lat": 46.1512,
    "lng": 14.9955,
    "limitSearch": ["SI"],
    "zoomLevel": 7,
    "name": "Slovenia"
  },
  "solomon_islands": {
    "lat": -9.4295,
    "lng": 160.0000,
    "limitSearch": ["SB"],
    "name": "Solomon Islands",
    "zoomLevel": 6
  },
  "south-africa": {
    "lat": -30.5595,
    "lng": 22.9375,
    "limitSearch": ["ZA"],
    "zoomLevel": 4,
    "name": "South Africa"
  },
  "south-america": {
    "lat": -10.0,
    "lng": -60.0,
    "limitSearch": ["AR", "BO", "BR", "CL", "CO", "EC", "GY", "PY", "PE", "SR", "UY", "VE"],
    "zoomLevel": 3,
    "name": "South America",
    "isRegion":true
  },
  "south-and-east-asia": {
    "lat": 19.8968,
    "lng": 99.6326,
    "limitSearch": ["AS"],
    "zoomLevel": 3,
    "name": "South And East Asia",
    "isRegion":true
  },
  "south_korea": {
    "lat": 35.9078,
    "lng": 127.7669,
    "limitSearch": ["KR"],
    "zoomLevel": 6,
    "name": "South Korea"
  },
  "spain": {
    "lat": 40.4637,
    "lng": -3.7492,
    "limitSearch": ["ES"],
    "name": "Spain"
  },
  "sri_lanka": {
    "lat": 7.8731,
    "lng": 80.7718,
    "limitSearch": ["LK"],
    "name": "Sri Lanka",
    "zoomLevel": 6
  },
  // "sweden": { "lat": 60.1282, "lng": 18.6435, "limitSearch": ["SE"] ,"zoomLevel": 3},
  "sweden": {
    "lat": 59.3293,
    "lng": 18.0686,
    "limitSearch": ["SE"],
    "name": "Sweden"
  },
  "switzerland": {
    "lat": 46.8182,
    "lng": 8.2275,
    "limitSearch": ["CH"],
    "zoomLevel": 7,
    "name": "Switzerland"
  },
  "switzerland_aletsch_glacier": {
    "lat": 46.44222,
    "lng": 8.07722,
    "limitSearch": ["CH"],
    "name": "Aletsch Glacier"
  },
  "sweden_abisko": {
    "lat": 68.3496,
    "lng": 18.8290,
    "limitSearch": ["SE"],
    "name": "Abisko"
  },
  "tajikistan": {
    "lat": 38.8610,
    "lng": 71.2761,
    "limitSearch": ["TJ"],
    "zoomLevel": 6,
    "name": "Tajikistan"
  },
  "tanzania": {
    "lat": -6.3690,
    "lng": 34.8888,
    "limitSearch": ["TZ"],
    "name": "Tanzania"
  },
  "thailand": {
    "lat": 15.8700,
    "lng": 100.9925,
    "limitSearch": ["TH"],
    "name": "Thailand"
  },
  "the_maldives": {
    "lat": 3.2028,
    "lng": 73.2207,
    "limitSearch": ["MV"],
    "name": "The Maldives",
    "zoomLevel": 6
  },
  "tonga": {
    "lat": -21.1790,
    "lng": -175.1982,
    "limitSearch": ["TO"],
    "name": "Tonga",
    "zoomLevel": 7
  },
  "tunisia": {
    "lat": 33.8869,
    "lng": 9.5375,
    "limitSearch": ["TN"],
    "name": "Tunisia"
  },
  "turkmenistan": {
    "lat": 38.9697,
    "lng": 59.5563,
    "limitSearch": ["TM"]
  },
  "turkey": {
    "lat": 38.9637,
    "lng": 35.2433,
    "limitSearch": ["TR"],
    "name": "Turkey",
    "zoomLevel": 5
  },
  "united-arab-emirates": {
    "lat": 24.0667,
    "lng": 53.8333,
    "limitSearch": ["AE"],
    "zoomLevel": 6,
    "name": "United Arab Emirates"
  },
  "united-kingdom": {
    "lat": 55.3781,
    "lng": -3.4360,
    "limitSearch": ["GB"],
    "name": "United Kingdom"
  },
  "united-states": {
    "lat": 37.0902,
    "lng": -95.7129,
    "limitSearch": ["US"],
    "name": "United States"
  },
  "uruguay": {
    "lat": -32.5228,
    "lng": -55.7658,
    "limitSearch": ["UY"],
    "name": "Uruguay",
    "zoomLevel": 6
  },
  "uzbekistan": {
    "lat": 41.3775,
    "lng": 64.5853,
    "limitSearch": ["UZ"],
    "name": "Uzbekistan"
  },
  "vietnam": {
    "lat": 16.0000,
    "lng": 108.0000,
    "limitSearch": ["VN"],
    "name": "Vietnam"
  },
  "vanuatu": {
    "lat": -15.3767,
    "lng": 166.9592,
    "limitSearch": ["VU"],
    "name": "Vanuatu"
  },
  "venezuela": {
    "lat": 6.4238,
    "lng": -66.5897,
    "limitSearch": ["VE"],
    "name": "Venezuela"
  },
  "zambia": {
    "lat": -13.1339,
    "lng": 27.8493,
    "limitSearch": ["ZM"],
    "name": "Zambia"
  }
}

// Section component for a website's hero section
// The Section Hero doesn't have any Blocks by default, all the configurations are made in the Section Hero settings
const SectionMap = props => {
  const {
    id,
    sectionId,
    className,
    rootClassName,
    title,
    options,
  } = props;

  const { pageId } = useParams();
  const [geoLocation, setGeoLocation] = useState(new LatLng(40.7128, -74.0060));
  const [mapState, setMapState] = useState({
    zoomLevel:2
  });
  const { country, region } = useParams();
  const isRegionPage = region !== undefined;
  const isCountryPage = country !== undefined;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const fetchPredictions = async () => {
    try {
      if (pageId && CORRDINATES[pageId]) {
        const coords = CORRDINATES[pageId];
        const newLocation = new LatLng(coords.lat, coords.lng);
        setGeoLocation(newLocation);
        const zoomLevel = coords.zoomLevel || 5;
        setMapState({zoomLevel})
        return newLocation;
      }
    } catch (error) {
      console.error('Error fetching predictions:', error);
    }
  };

  useEffect(() => fetchPredictions(title?.content), [title?.content]);

  return (
    <SectionContainer
      id={id}
      className={className}
      rootClassName={classNames(rootClassName || css.root)}
      appearance={{}}
      options={fieldOptions}
    >
      <div className={css.mapBox}>
        <Map
          center={geoLocation}
          zoom={mapState.zoomLevel || 5}
          places={[]}
          useStaticMap={false}
        />
      </div>
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionMap.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  isInsideContainer: false,
  options: null,
};

SectionMap.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionMap;
